import { type FC } from "react";
import { Stack, Typography } from "@mui/material";

export interface TwoLineDropdownItemProps {
	readonly primaryText: string;
	readonly secondaryText: string;
}

export const TwoLineDropdownItem: FC<TwoLineDropdownItemProps> = ({ primaryText, secondaryText }) => {
	return (
		<Stack>
			<Typography variant="body2">{primaryText}</Typography>
			<Typography variant="caption" color="text.secondary">
				{secondaryText}
			</Typography>
		</Stack>
	);
};

export default TwoLineDropdownItem;
